import type { AccountRequirements } from '@identity/domain/types';

/**
 * The requirements still pending, as one sorted comma-separated tag value, for example
 * `'EMAIL,PASSWORD'`.
 *
 * It makes the blocked population derivable from the status log alone, so the gate needs no event of
 * its own. Sorting matters: without it the same set would produce different values depending on how
 * the backend serialised the map, splitting one population into several.
 *
 * These are contract keys, never values of the account, so there is no PII in it.
 */
export const pendingRequirementsTag = (requirements: AccountRequirements): string =>
  Object.keys(requirements)
    .filter((key) => requirements[key as keyof AccountRequirements] === false)
    .sort()
    .join(',');
